(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/now.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/components/now.js');
"use strict";

const {
  useEffect
} = React;
const {
  DATE_AND_TIME
} = svs.tickets_giftshop.constants.names;
const {
  NOW
} = svs.tickets_giftshop.constants.dateSelectorKey;
const Now = _ref => {
  let {
    date,
    onInputChange
  } = _ref;
  useEffect(() => {
    const now = svs.utils.date.SimpleDate(new Date());
    if (date !== now) {
      onInputChange({
        target: {
          value: {
            date: now,
            time: svs.utils.date.FormatTime(),
            dateSelectorUsed: NOW
          },
          name: DATE_AND_TIME
        }
      });
    }
  }, [date, onInputChange]);
  return React.createElement("div", {
    className: "tg-date-input gutter-sm-2"
  }, React.createElement("div", {
    className: "grid-row"
  }, React.createElement("div", {
    className: "col-xs-12"
  }, React.createElement("p", {
    className: "tg-form-date-send-now-info"
  }, "G\xF6r du inga \xE4ndringar skickas lotterna direkt efter betalning."), React.createElement("p", {
    className: "tg-form-date-send-now-info"
  }, "V\xE4ljer du en temadag eller namnsdag skickas lotten klockan 8:00 den valda dagen, eller direkt om du k\xF6per efter 08:00 den aktuella dagen."))));
};
svs.tickets_giftshop.gift.giftform.date_selector.components.Now = Now;

 })(window);